import { action, observable } from 'mobx'

import Ds from './ds'

class Sources {
  @observable data = []

  @observable ds = new Ds()

  @action loadAllSources() {
    this.ds.query(`{ sources(hash: "${ localStorage.getItem('userHash') }") { id name } }`, (data) => {
      this.data = data.sources
    })
  }

  @action newSource(name) {
    this.ds.query(`mutation { addSource(name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllSources()
    })
  }

  @action updateSource(id, name) {
    this.ds.query(`mutation { updateSource(id: ${ id }, name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllSources()
    })
  }

  @action deleteSource(id) {
    this.ds.query(`mutation { deleteSource(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllSources()
    })
  }
}

export default new Sources()



// WEBPACK FOOTER //
// ./src/stores/sources.js